// extracted by mini-css-extract-plugin
module.exports = {"transaction":"styles_transaction__19cRE","item":"styles_item__3PWUt","price":"styles_price__3_jOZ","ref":"styles_ref__1yvrX","button":"styles_button__349d8"};